import get from 'lodash/get';

export const selectShowCreateEditModal = (state) =>
  get(state, 'credentials.showCreateEditModal', false);
export const selectCredentialCreateEdit = (state) =>
  get(state, 'credentials.createEdit', {});
export const selectCredentialId = (state) =>
  get(state, 'credentials.createEdit.id', '');
export const selectCredentialUsername = (state) =>
  get(state, 'credentials.createEdit.value.username', '');
export const selectCredentialClientEndpoint = (state) =>
  get(state, 'credentials.createEdit.value.endpoint', '');
export const selectCredentialPassword = (state) =>
  get(state, 'credentials.createEdit.value.password', '');
export const selectCredentialLeakDate = (state) =>
  get(state, 'credentials.createEdit.value.leak_date', null);
export const selectCredentialOwned = (state) =>
  get(state, 'credentials.createEdit.value.owned', false);
export const selectCredentialLinkedVulns = (state) =>
  get(state, 'credentials.createEdit.value.vulnerabilities', []);
export const selectErrorCreateCredential = (state) =>
  get(state, 'credentials.errorCreateCredential', false);
export const selectShowDetail = (state) =>
  get(state, 'credentials.showDetail', false);
export const selectCredentialDetail = (state) =>
  get(state, 'credentials.credentialDetail', {});
export const selectCredentialsList = (state) =>
  get(state, 'credentials.credentialsList', []);
export const selectCredentialsSelected = (state) =>
  get(state, 'credentials.credentialsSelected', []);
export const selectShowContextMenu = (state) =>
  get(state, 'credentials.showContextMenu', false);
export const selectContextMenuXPos = (state) =>
  get(state, 'credentials.contextMenuXPos', 0);
export const selectContextMenuYPos = (state) =>
  get(state, 'credentials.contextMenuYPos', 0);
export const selectShowImport = (state) =>
  get(state, 'credentials.showImport', false);
export const selectFiles = (state) =>
  get(state, 'credentials.filesToUpload', []);
export const selectUploadState = (state) =>
  get(state, 'credentials.uploadState', '');
export const selectFileIndex = (state) =>
  get(state, 'credentials.fileIndex', -1);
export const selectErrorFilesList = (state) =>
  get(state, 'credentials.errorFilesList', []);
export const selectCurrentUploadState = (state) =>
  get(state, 'credentials.currentUploadState', '');
export const selectCurrentUploadPercent = (state) =>
  get(state, 'credentials.currentUploadPercent', 0);
export const selectCurrentUploadError = (state) =>
  get(state, 'credentials.currentUploadError', '');
export const selectIsExportingCSV = (state) =>
  get(state, 'credentials.isExportingCSV', false);
export const selectError = (state) => get(state, 'credentials.error', false);
export const selectErrorMessage = (state) =>
  get(state, 'credentials.errorMessage', '');
export const selectAvailableVulns = (state) =>
  get(state, 'credentials.availableVulns', []);
export const selectModalBulkUpdateField = (state) =>
  get(state, 'credentials.bulkUpdateField', '');
export const selectModalBulkUpdateValue = (state) =>
  get(state, 'credentials.bulkUpdateValue', '');
export const selectIsFetching = (state) =>
  get(state, 'credentials.isFetching', '');
export const selectCount = (state) =>
  get(state, 'credentials.count', 0);
export const selectDeleteConfirmation = (state) =>
  get(state, 'credentials.showDeleteConfirmation', false);
export const selectCredentialIdToDelete = (state) =>
  get(state, 'credentials.credentialToDelete', 0);
export const selectFetchingVulns = (state) =>
  get(state, 'credentials.isFetchingVulns', false);
export const selectFetchingCredential = (state) =>
  get(state, 'credentials.fetchingCredential', false);
